import { normalizeApiBaseUrl, type AppConfig } from '@edice/shared';
import { bootstrapAuthenticatedApp } from '@edice/shared/auth';
import '@edice/shared/shell.css';
import { registerSW } from 'virtual:pwa-register';

const config: AppConfig = {
  appKind: 'facility',
  appName: 'eDICE Fasiliti',
  shortName: 'eDICE',
  description: 'Hab komunikasi, kandungan, rekod ADR/PF7 dan analisa untuk fasiliti di Negeri Perak.',
  environment: (import.meta.env.VITE_APP_ENV || 'development') as AppConfig['environment'],
  apiBaseUrl: normalizeApiBaseUrl(import.meta.env.VITE_API_BASE_URL),
  accent: '#166b50',
  modules: [
    { id: 'pengumuman', label: 'Pengumuman', description: 'Hebahan dan maklumat terkini untuk fasiliti.', status: 'available' },
    { id: 'kalendar', label: 'Kalendar', description: 'Aktiviti yang diterbitkan kepada fasiliti.', status: 'available' },
    { id: 'maklum-balas', label: 'Maklum Balas', description: 'Tindakan dan komunikasi dua hala.', status: 'available' },
    { id: 'adr', label: 'ADR / AEFI', description: 'Rekod, semakan data dan analisa ADR.', status: 'available' },
    { id: 'pf7', label: 'PF7', description: 'Rekod dan analisa laporan PF7.', status: 'planned' },
    { id: 'dokumen', label: 'Dokumen', description: 'Formulari, status ubat dan dokumen rujukan.', status: 'available' }
  ]
};

const root = document.querySelector<HTMLElement>('#app');
if (!root) throw new Error('Elemen aplikasi tidak dijumpai.');

void bootstrapAuthenticatedApp(root, config, {
  clientId: import.meta.env.VITE_GOOGLE_CLIENT_ID || '',
  allowedDomain: import.meta.env.VITE_GOOGLE_DOMAIN || 'moh.gov.my',
  authMode: import.meta.env.VITE_AUTH_MODE === 'google' ? 'google' : 'mock'
});
registerSW({ immediate: true });
